"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertWildcardUrlStringToRegExp = convertWildcardUrlStringToRegExp;
function convertWildcardUrlStringToRegExp(url) {
    return new RegExp(`^${url.replace(/([:/.])/g, '\\$1').replace(/\*/g, '(.*)')}$`);
}
